import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#111111] mt-auto">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-12 border-b border-white/10">
          <div className="lg:col-span-4">
            <Link to="/" className="inline-flex items-center mb-6">
              <img
                src="https://storage.readdy-site.link/project_files/1caa1cee-5f7c-4340-8ab6-e4fecf0e11fe/5ee83760-d348-4b18-a1b6-b409430da712_tmp5zjj6o9t.webp?v=62c8a9ba617712446a98074483998f7e"
                alt="The Design Proposal Logo"
                className="h-10 w-auto object-contain invert"
              />
            </Link>
            <p className="text-sm text-white/50 leading-relaxed mb-6 max-w-xs">
              Professional interior design planning services that bring clarity, confidence, and beauty to your space — nationwide.
            </p>
            <div className="space-y-3">
              <a
                href="tel:+18005550199"
                className="flex items-center gap-3 text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-white/5 rounded-lg border border-white/10">
                  <i className="ri-phone-line text-[#C9A961] text-sm"></i>
                </div>
                (800) 555-0199
              </a>
              <a
                href="mailto:hello@thedesignproposal.com"
                className="flex items-center gap-3 text-sm text-white/70 hover:text-[#C9A961] transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-white/5 rounded-lg border border-white/10">
                  <i className="ri-mail-line text-[#C9A961] text-sm"></i>
                </div>
                hello@thedesignproposal.com
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold text-white uppercase tracking-widest mb-5">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-sm text-white/50 hover:text-[#C9A961] transition-colors">Design Proposals</Link></li>
              <li><Link to="/services" className="text-sm text-white/50 hover:text-[#C9A961] transition-colors">Renovation Planning</Link></li>
              <li><Link to="/services" className="text-sm text-white/50 hover:text-[#C9A961] transition-colors">Material Selection</Link></li>
              <li><Link to="/services" className="text-sm text-white/50 hover:text-[#C9A961] transition-colors">Room Packages</Link></li>
              <li><Link to="/services" className="text-sm text-white/50 hover:text-[#C9A961] transition-colors">Virtual Consultations</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold text-white uppercase tracking-widest mb-5">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-white/50 hover:text-[#C9A961] transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-sm text-white/50 hover:text-[#C9A961] transition-colors">About Us</Link></li>
              <li><Link to="/location" className="text-sm text-white/50 hover:text-[#C9A961] transition-colors">Service Areas</Link></li>
              <li><Link to="/#process" className="text-sm text-white/50 hover:text-[#C9A961] transition-colors">Our Process</Link></li>
              <li><Link to="/#testimonials" className="text-sm text-white/50 hover:text-[#C9A961] transition-colors">Client Stories</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-xs font-semibold text-white uppercase tracking-widest mb-5">Start Your Project</h4>
            <p className="text-sm text-white/50 mb-6 leading-relaxed">
              Ready to design your space with confidence? Request a personalized proposal today — delivered in 5–14 business days.
            </p>
            <Link
              to="/#proposal"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#C9A961] text-white text-sm font-medium px-6 py-3 rounded-md hover:bg-[#b8924d] transition-colors duration-300 cursor-pointer mb-4"
            >
              Get Your Design Proposal
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
            <p className="text-xs text-white/30">Virtual services available in all 50 states</p>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} The Design Proposal. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-white/30 hover:text-[#C9A961] transition-colors">Privacy Policy</a>
            <a href="#" className="text-xs text-white/30 hover:text-[#C9A961] transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
